import { Box, Button, Typography } from "@mui/material";
import EmptyTemplate from "../../../../shared/assets/ilustrations/EmptyTemplates.png";

export default function TemplatesEmptyState({ onCreate }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="calc(100vh - 120px)"
      width="100%"
    >
      <Box width={{ xs: "80%", sm: "auto" }} textAlign="center">
        <Box
          component="img"
          src={EmptyTemplate}
          alt="Você não tem modelos"
          sx={{
            width: { xs: 247, sm: 494 },
            height: { xs: 165, sm: 330 },
            display: "block",
            margin: "0 auto",
          }}
        />

        <Box mt={3} display="flex" flexDirection="column" gap={1.5}>
          <Typography
            variant="h5"
            fontWeight={700}
            color="primary"
          >
            Parece que você não tem modelos
          </Typography>

          <Typography variant="body1" color="text.secondary">
            Crie um agora mesmo, é fácil e rápido
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{ mt: 2, alignSelf: "center", px: 4 }}
            onClick={onCreate}
          >
            Criar Modelo
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
